import { render, staticRenderFns } from "./ProductInsights.vue?vue&type=template&id=0005e5d2&scoped=true&"
import script from "./ProductInsights.vue?vue&type=script&lang=js&"
export * from "./ProductInsights.vue?vue&type=script&lang=js&"
import style0 from "./ProductInsights.vue?vue&type=style&index=0&id=0005e5d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0005e5d2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0005e5d2')) {
      api.createRecord('0005e5d2', component.options)
    } else {
      api.reload('0005e5d2', component.options)
    }
    module.hot.accept("./ProductInsights.vue?vue&type=template&id=0005e5d2&scoped=true&", function () {
      api.rerender('0005e5d2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/ProductInsights.vue"
export default component.exports